/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import { Avatar, Tooltip, Typography } from 'antd';

// Misc imports
import { BotIcon } from '../Icons/BotIcon';
import { truncate } from '../../utils/string/truncate';

// Constant declarations
const baseClassName = 'bot-avatar';

const BotAvatar = (props) => {
  const {
    bot,
    avatarSize = 24,
    showBotName = true,
    wrapBotName = false,
    isMuted = false,
    maxNameCharacters,
    className = '',
    ellipsis,
    ...restProps
  } = props;

  const [hasError, setHasError] = useState(false);
  const { t } = useTranslation();

  return (
    <span className={`${baseClassName} ${className}`} {...restProps}>
      <Avatar
        src={bot?.image}
        shape="square"
        size={avatarSize}
        className={classNames('flex-none', {
          'bg-primary': hasError || !bot?.image
        })}
        onError={() => setHasError(true)}
      >
        <BotIcon />
      </Avatar>

      {
        showBotName ? (
          <Fragment>
            {
              bot?.displayName?.trim() ? (
                <Tooltip
                  title={wrapBotName && bot.displayName.length > 35 && bot.displayName}
                  mouseEnterDelay={1}
                  placement="rightTop"
                >
                  <Typography.Paragraph
                    ellipsis={ellipsis || !wrapBotName}
                    className={classNames('ml-3 mb-0', {
                      'text-muted': isMuted
                    })}
                  >
                    {maxNameCharacters ? truncate(bot.displayName, maxNameCharacters, '...') : bot.displayName}
                  </Typography.Paragraph>
                </Tooltip>
              ) : (
                <Typography.Text type="secondary" ellipsis className="ml-3">
                  {t('(no name)')}
                </Typography.Text>
              )
            }
          </Fragment>
        ) : null
      }
    </span>
  );
};

BotAvatar.propTypes = {
  bot: PropTypes.object,
  avatarSize: PropTypes.number,
  showBotName: PropTypes.bool,
  wrapBotName: PropTypes.bool,
  isMuted: PropTypes.bool,
  maxNameCharacters: PropTypes.number,
  className: PropTypes.string,
  ellipsis: PropTypes.object
};

export default BotAvatar;
